module.exports = __webpack_public_path__ + "img/1.48e3aff9.jpg";